import { render, staticRenderFns } from "./EfsCard.vue?vue&type=template&id=0dc1e815&scoped=true"
import script from "./EfsCard.vue?vue&type=script&lang=js"
export * from "./EfsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1e815",
  null
  
)

export default component.exports